import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';
import { useAppSelector } from '@redux/store';

interface TapRequesetStateType {
  isLoading: boolean;
  isStarted: boolean;
  isCompleted: boolean;
}

interface UseClaimResourceReturnType {
  tapRequestState: TapRequesetStateType;
  setTapRequestState: Dispatch<SetStateAction<TapRequesetStateType>>;
}

const useTapRequestComplete = (id?: string): UseClaimResourceReturnType => {
  const [tapRequestState, setTapRequestState] = useState<TapRequesetStateType>({
    isLoading: false,
    isStarted: false,
    isCompleted: false,
  });
  const tapObject = useAppSelector((state) => state.quarry.tap);

  useEffect(() => {
    if (id) {
      if (!tapObject[id] && tapRequestState.isStarted) {
        setTapRequestState({
          isLoading: false,
          isStarted: false,
          isCompleted: true,
        });
      }
    } else {
      const isAllTapSend = Object.entries(tapObject).every((arr) => !arr[1]);

      if (isAllTapSend && tapRequestState.isStarted) {
        setTapRequestState({
          isLoading: false,
          isStarted: false,
          isCompleted: true,
        });
      }
    }
  }, [tapRequestState.isStarted, tapObject, id]);

  return { tapRequestState, setTapRequestState };
};

export { useTapRequestComplete };
